import { Injectable } from '@angular/core';
import { environment } from '@web-nx-ng-tsc/util-environment';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  constructor() {
    console.error('@@@name@@@', environment.name);
    console.error('@@@logging@@@', environment.loggingEnabled);
    console.error('@@@phase@@@', environment.phase);
  }

  info(...args: any[]) {
    if (environment.loggingEnabled && environment.phase === 'dev'){
      console.info(...args);
    }
  }

  log(...args: any[]) {
    if (environment.loggingEnabled && environment.phase === 'dev'){
      console.log(...args);
    }
  }

  warn(...args: any[]) {
    if (environment.loggingEnabled && environment.phase === 'dev'){
      console.warn(...args);
    }
  }

  error(...args: any[]) {
    if (environment.loggingEnabled ){
      console.error(...args);
    }
  }
}
